import { render, staticRenderFns } from "./DesktopHeader.vue?vue&type=template&id=0c2e4902&"
import script from "./DesktopHeader.vue?vue&type=script&lang=ts&"
export * from "./DesktopHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports